export enum GameElement {
    Vegetable = "Vegetable",
    EatingMole = "EatingMole",
    AttackingMole = "AttackingMole",
    AggressiveEaterMole = "AggressiveEaterMole",
    TutorialMole = "TutorialMole",
    Portal = "Portal",
    WeaponsBox = "WeaponsBox",
    HealBox = "HealBox",
    BoosterBox = "BoosterBox"
}

export function isEnemy(value: GameElement): boolean {
    return ENEMIES.includes(value) || isBox(value);
}

export function isBox(value: GameElement): boolean {
    return BOXES.includes(value);
}

const ENEMIES: ReadonlyArray<GameElement> = [
    GameElement.AttackingMole,
    GameElement.EatingMole,
    GameElement.AggressiveEaterMole,
];

const BOXES: ReadonlyArray<GameElement> = [
    GameElement.WeaponsBox,
    GameElement.HealBox,
    GameElement.BoosterBox
];

const MOLES: ReadonlyArray<GameElement> = [
    GameElement.EatingMole,
    GameElement.AggressiveEaterMole,
    GameElement.AttackingMole
] as const;

export { ENEMIES, BOXES, MOLES };